import Model from 'ducker-model';

// 1.定义property
const property = {
  postId: String,
  questionId: String,
  title: String,
  time: String,
  answerNum: Number,
  adoptedNum: Number,
};

// 2.定义replacedKeyFromPropertyName
const replacedKeyFromPropertyName = {
  postId: {
    property: 'PostId',
    defaultValue: '--',
  },
  questionId: {
    property: 'QuestionId',
    defaultValue: '--',
  },
  title: {
    property: 'Title',
    defaultValue: '--',
  },
  time: {
    property: 'PublishTime',
    defaultValue: '--',
  },
  answerNum: {
    property: 'AnswerNum',
    defaultValue: 0,
  },
  adoptedNum: {
    property: 'AdoptedNum',
    defaultValue: 0,
  },
};
export default new Model(property, replacedKeyFromPropertyName);
